export const SEARCH_DEBOUNCE_MS = 400;

export const CATEGORY_TONE: Record<string, { bg: string; color: string }> = {
  AUTH: { bg: 'rgba(139,92,246,0.14)', color: '#7c5cf0' },
  CONFIG: { bg: 'rgba(13,148,136,0.14)', color: '#0d9488' },
  CARD: { bg: 'rgba(91,127,255,0.14)', color: '#5b7fff' },
  SESSION: { bg: 'rgba(100,116,139,0.16)', color: '#64748b' },
  VALIDATION: { bg: 'rgba(202,138,4,0.16)', color: '#a16207' },
  INTERNAL: { bg: 'rgba(219,39,119,0.14)', color: '#db2777' },
  FALLBACK: { bg: 'rgba(100,116,139,0.16)', color: '#64748b' },
  GENERAL: { bg: 'rgba(100,116,139,0.12)', color: '#64748b' },
};

export const SEVERITY_TONE: Record<string, { dot: string; text: string }> = {
  CRITICAL: { dot: '#ef4444', text: '#dc2626' },
  HIGH: { dot: '#f97316', text: '#ea580c' },
  MEDIUM: { dot: '#eab308', text: '#a16207' },
  LOW: { dot: '#22c55e', text: '#16a34a' },
};
